import { IconProps } from "@/types/types";

export default function Close({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.3049 4.92886C17.7931 4.44071 18.5845 4.4407 19.0727 4.92886C19.5608 5.41701 19.5608 6.20847 19.0727 6.69662L13.7694 11.9999L19.0727 17.3032C19.5608 17.7914 19.5608 18.5829 19.0727 19.071C18.5845 19.5592 17.7931 19.5592 17.3049 19.071L12.0016 13.7677L6.69834 19.071C6.21018 19.5591 5.41872 19.5591 4.93057 19.071C4.44241 18.5828 4.44241 17.7913 4.93057 17.3032L10.2338 11.9999L4.93057 6.69667C4.44242 6.20852 4.44242 5.41706 4.93057 4.92891C5.41873 4.44075 6.21018 4.44076 6.69834 4.92891L12.0016 10.2322L17.3049 4.92886Z" fill="currentColor" />
        </svg>
    )
}

